import { highlightText } from "./highlight";
import { ReactNode } from "react";

export function HighlightText({ value, words }: { value: string; words?: string[] }): ReactNode {
  if (!words?.length) return <>{value}</>;
  const parts = highlightText(value, words);
  if (typeof parts === "string") return <>{parts}</>;
  return (
    <span>
      {parts.map((part, i) => (part.highlighted ? <mark key={i}>{part.text}</mark> : part.text))}
    </span>
  );
}
